import { render } from "./LeaveApproval.vue?vue&type=template&id=19c1e39c&scoped=true"
import script from "./LeaveApproval.vue?vue&type=script&lang=js"
export * from "./LeaveApproval.vue?vue&type=script&lang=js"

import "./LeaveApproval.vue?vue&type=style&index=0&id=19c1e39c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c1e39c"]])

export default __exports__